export const checkoutUrl =
  'https://hybrid-race-coach-ready.impultienda.ar/checkout'

export const ctaLabel = 'GET THE COMPLETE COACHING LIBRARY NOW'
export const ctaLabelSystem = 'GET THE COMPLETE 6-IN-1 SYSTEM NOW'

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Hybrid Race Coach Ready — Complete 6-in-1 Coaching System',
    value: 27,
    currency: 'USD',
  })
}

export const packageContents: string[] = [
  'Volume 1 — Hybrid Racing Foundations & 25 Sessions',
  'Volume 2 — Running Under Fatigue & 25 Sessions',
  'Volume 3 — Sled, Carries & Strength & 25 Sessions',
  'Volume 4 — SkiErg, Rowing & Engine & 25 Sessions',
  'Volume 5 — Wall Balls, Burpees & High-Fatigue Stations',
  'Volume 6 — Race Simulation, Strategy & Performance',
  'Bonus 1 — 150 Hybrid Racing Drills Library',
  'Bonus 2 — 100 Mistakes, Coaching Cues & Corrections',
  'Bonus 3 — 50 Ready-to-Run Race Simulation Workouts',
  'Bonus 4 — Athlete Assessment, Benchmark & Progress Tracking System',
  'Bonus 5 — 40 Emergency Sessions, Small-Group Workouts & Limited-Equipment Plans',
  '7-Day Money-Back Guarantee',
  'Instant Access',
  'Pay in Your Local Currency',
  'PDF Format — Ready to Use',
]

export const finalIncludedItems: string[] = packageContents
